import {
  GET_TRANSCRIPTION_SUCCESS,
  GET_TRANSCRIPTION_FAILURE,
  GET_TRANSCRIPTION_REQUESTED,
  GET_CACHED_TRANSCRIPTION,
  EXPIRE_CACHED_TRANSCRIPTION,
} from './transcription.constants'
import { CACHE_EXPIRY_TIME } from './transcription.cache'
import API from './transcription.api'

export const getCachedTranscription = contactId => ({
  type: GET_CACHED_TRANSCRIPTION,
  contactId,
})

export const getTranscription = (contactId, isRootRecording) => {
  return async dispatch => {
    dispatch(getTranscriptionRequested())
    try {
      const transcription = await API.getTranscription(contactId, isRootRecording)
      dispatch(getTranscriptionSuccess(transcription))
      setTimeout(() => {
        dispatch(expireCachedTranscription(transcription.ccrId))
      }, CACHE_EXPIRY_TIME)
    } catch (error) {
      dispatch(getTranscriptionFailure(error))
    }
  }
}

export const expireCachedTranscription = ccrid => ({
  type: EXPIRE_CACHED_TRANSCRIPTION,
  ccrid,
})

export const getTranscriptionRequested = () => ({
  type: GET_TRANSCRIPTION_REQUESTED,
})

export const getTranscriptionSuccess = data => ({
  data,
  type: GET_TRANSCRIPTION_SUCCESS,
})

export const getTranscriptionFailure = error => ({
  error,
  type: GET_TRANSCRIPTION_FAILURE,
})
